/**
 * Global Toast Notification System - Optimized Module Version
 */
const ToastManager = {
  container: null,

  init() {
    if (!this.container) {
      this.container = document.createElement("div");
      this.container.className = "toast-master-container";
      document.body.appendChild(this.container);
    }
  },

  show(type, title, message) {
    this.init();

    const toast = document.createElement("div");
    toast.className = `toast-item ${type}`;

    const icons = {
      success:
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>',
      error:
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>',
      info: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>',
    };

    toast.innerHTML = `
      <div class="toast-icon">${icons[type] || icons.info}</div>
      <div class="toast-content">
        ${title ? `<div class="toast-title">${this.escapeHtml(title)}</div>` : ""}
        <div class="toast-message">${this.escapeHtml(message)}</div>
      </div>
      <button class="toast-close" aria-label="Kapat">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    `;

    // Yeni gelen toast her zaman en üstte görünsün istersen prepend kullanabilirsin
    this.container.appendChild(toast);

    // Kapatma butonu olay dinleyicisi
    toast.querySelector(".toast-close").onclick = (e) => {
      e.stopPropagation();
      this.remove(toast);
    };

    // Belirlenen süre sonunda otomatik kaldır
    const autoRemoveTimeout = setTimeout(() => this.remove(toast), 5000);

    // Kullanıcı toast üzerine gelirse otomatik kaldırmayı durdur (isteğe bağlı konfor özelliği)
    toast.onmouseenter = () => clearTimeout(autoRemoveTimeout);
    toast.onmouseleave = () => {
      // Mouse ayrıldıktan 2.5 saniye sonra kaldır
      setTimeout(() => this.remove(toast), 2500);
    };
  },

  remove(toast) {
    if (!toast || toast.classList.contains("leaving") || !toast.parentNode) return;

    // CSS animasyonunu tetikleyen sınıfı ekle
    toast.classList.add("leaving");

    // CSS'deki toastExit süresi (400ms) ile uyumlu olarak DOM'dan kaldır
    setTimeout(() => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    }, 400);
  },

  escapeHtml(text) {
    if (!text) return "";
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  },
};

export const Toast = {
  success: (title, message) => ToastManager.show("success", title, message),
  error: (title, message) => ToastManager.show("error", title, message),
  info: (title, message) => ToastManager.show("info", title, message),
};
